// ItemModal.js
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "baseui/modal";
import { ParagraphMedium } from "baseui/typography";
import { RESOURCE_TYPES } from "../../constants/AppEnums";
export default function ItemModal({
  item,
  resourceType,
  imageSrc,
  isOpen,
  onClose,
}) {
  return (
    <Modal onClose={onClose} isOpen={isOpen} autoFocus animate>
      <ModalHeader>{item.title}</ModalHeader>
      <ModalBody>
        <img src={imageSrc} alt={item.title} style={{ width: "100%" }} />
        <ParagraphMedium>{item.description}</ParagraphMedium>
      </ModalBody>
      <ModalFooter>
        {resourceType === RESOURCE_TYPES.PRODUCT ? (
          <p>Price: ${item.price}</p>
        ) : (
          <>
            <p>Updated: {item.timeSinceCreated}</p>
            <p>Creator: {item.creator || "deleted"}</p>
          </>
        )}
      </ModalFooter>
    </Modal>
  );
}
